import $ from "jquery";

import { price } from "../../lib/utils";
import "../../lib/cycle";

import "./index.scss";

const $webProductCollectionMembers = $(".product__typeselection");
$webProductCollectionMembers.find("input").on("change", function c() {
  const $el = $(this);
  $el
    .parents(".productcard")
    .find(".productcard__info__price__price")
    .text(price($el.data("price"), false));
});

$(".category__filter_mobile").on("change", function change() {
  window.document.location = $(this).val();
});

$(".category__products__list").each((idx, el) => {
  const $productcard = $(el).find(".productcard__cell");

  if ($productcard.length % 4 === 1) {
    // crappy flow fix; adds a dummy last card
    const $dummy = $("<div>&nbsp;</div>")
      .css({
        minHeight: $productcard.last().height(),
        height: $productcard.last().height()
      })
      .addClass("productcard__cell")
      .addClass("productcard__dummy");
    $productcard.parents(".category__products__list").append($dummy);

    if (window.IntersectionObserver) {
      const o = new IntersectionObserver(entries => {
        if (entries.length) {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const $el = $(entry.target);
              if (!$el.prop("intersected")) {
                const height = $productcard.height() + parseInt($productcard.css("padding").replace("px", ""), 10) * 2;
                $el.prop("intersected", 1).css({
                  height,
                  minHeight: height
                });
                if (o.unobserve) {
                  o.unobserve($el.get(0));
                }
              }
            }
          });
        }
      });
      o.observe($dummy.get(0));
    }
  }
});

const $productcard = $(".productcard");
// crappy firefox fix
$productcard
  .on("mouseover", function e() {
    $(this).addClass("productcard_hovered");
  })
  .on("mouseleave", function e() {
    $(this).removeClass("productcard_hovered");
  });

const $body = $("body");

$productcard
  .on("mouseover click", ".product__typeselection__selection", function mouseover(e) {
    const wpcId = $(this).data("id");
    const $container = $(e.delegateTarget);
    $container
      .find(`input[name="productCollectionMember${$container.data("id")}"]`)
      .prop("checked", "")
      .filter(function filter() {
        return parseInt($(this).val(), 10) === wpcId;
      })
      .prop("checked", "checked")
      .trigger("change");
  })
  .on("mouseleave", function mouseleave() {
    const $container = $(this);
    $container
      .find(`input[name="productCollectionMember${$container.data("id")}"]`)
      .prop("checked", "")
      .first()
      .prop("checked", "checked")
      .trigger("change");
  })
  .on("change click", ".product__typeselection__selection", function click(e) {
    const $container = $(e.delegateTarget);
    // on mobile do not click through
    if (!$body.hasClass("is-mobile")) {
      window.document.location = `${$container.find("a").prop("href")}#selectItem=${$(this).data("id")}`;
    }
    return true;
  })
  .on("change", "select", function change(e) {
    const $container = $(e.delegateTarget);
    window.document.location = `${$container.find("a").prop("href")}#selectItem=${$(this).val()}`;
  })
  .on("click", "button", e => {
    const $container = $(e.delegateTarget);
    const val = $container.find("input:checked,select").val();
    window.document.location = `${$container.find("a").prop("href")}${val ? `#selectItem=${val}` : ""}`;

    return false;
  });
